"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var st_1 = require("../../st/st");
exports.inject = function (ctor, constructorArgument) {
    return function (instance, propName) {
        Object.defineProperty(instance, propName, {
            value: st_1.st.di.get(ctor, constructorArgument)
        });
    };
};
//# sourceMappingURL=inject.js.map